module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component component-backoffice-driver-notes"
  }, [(_vm.type === 'noteCard') ? _c('span', [_c('ModalReveal', {
    staticClass: "p-0 m-0"
  }, [_c('a', {
    staticClass: "pr-2 fa fa-comment fa-lg",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [(_vm.notes > 0) ? _c('span', {
    staticClass: "badge success"
  }, [_vm._v(_vm._s(_vm.notes))]) : _vm._e()]), _c('label', [_vm._v("Add note"), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.pushNote($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.description),
      expression: "body.description"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.body.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "description", $event.target.value)
      }
    }
  })]), _c('ActionButton', {
    attrs: {
      "action": _vm.pushNote
    }
  }, [_vm._v("Add")])], 1), _c('h2', [_vm._v("Notes")]), _c('base-list', {
    ref: "baseList",
    attrs: {
      "component": _vm.component,
      "dataLoader": _vm.dataLoader,
      "showPerPageSelect": false,
      "componentType": "table"
    }
  })], 1)], 1) : _vm._e(), (_vm.type === 'highlightedNotes') ? _c('div', {
    staticClass: "div"
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-233fc571!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/DriverNote.vue
// module id = 2325
// module chunks = 1